<template>
    <div class="col-xs-12 col-sm-6 col-sm-offset-3 flex justify-between items-center">
        <GreyButton @click="$emit('backClick')" style="width:46%">{{back}}</GreyButton>
        <TooliabaButton @click="$emit('forwardClick')" style="width:46%" :enabled="enabledForward">{{forward}}</TooliabaButton>
    </div>
</template>

<script>
import GreyButton from '@/components/buttons/GreyButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    props: {
        back: {
            type: String
        },
        forward: {
            type: String
        },
        enabledForward: {
            type: Boolean,
            default: true
        }
    },
    components: {
        GreyButton,
        TooliabaButton
    }
};
</script>
